import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler } from '@angular/common/http';

@Injectable()
export class TimezoneInterceptor implements HttpInterceptor {
  // It is calculated only once when the app loads
  private readonly tz = Intl.DateTimeFormat().resolvedOptions().timeZone;

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const cloned = req.clone({
      setHeaders: { 'X-Timezone': this.tz }
    });
    return next.handle(cloned);
  }
}